import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { TopBarComponent } from 'src/app/top-bar/top-bar.component';
import { AggregateService, FilterService, GridComponent, SelectionSettingsModel, SortService } from '@syncfusion/ej2-angular-grids';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { forkJoin, Observable, Subject, takeUntil } from 'rxjs';
import { ACHAutoPayService } from 'src/app/services/achAutoPay.service';
import { IVendorACHAutoPay } from 'src/app/Shared/Interfaces/IACHAutoPay';
import Swal from 'sweetalert2';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';
import { ITwoDigitDecimalInput, IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { TwoDigitDecimalDirective } from 'src/app/Shared/restrictToTwoDigitDecimal.directive';
import { ToastrService } from 'ngx-toastr';
import { VendorService } from 'src/app/services/Vendor.service';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { GeneralService } from 'src/app/services/general.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EActionTypes, EToaster, EUserSecurityFunctionID, RentalReceiptIDs } from 'src/app/Shared/enum';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { PaymentService } from 'src/app/services/payment.service';
declare var bootstrap: any;

@Component({
  selector: 'app-ops-process-ach-payment',
  standalone: true,
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES, TwoDigitDecimalDirective, OperationsComponent, WordReplacePipe,
    VendorSearchComponent, UserPermissionHandlerDirective, LoaderComponent],
  providers: [AggregateService, ACHAutoPayService, FilterService, SortService ],
  templateUrl: './ops-process-ach-payment.html',
  styleUrl: './ops-process-ach-payment.scss'
})
export class OpsProcessAchPayment implements OnInit, OnDestroy{
  isCollapsed: boolean = true;
  loaderIcon: Promise<boolean>;
  private destroy$ = new Subject<void>();
  @ViewChild('gridAch', { static: false }) public gridAch: GridComponent;
  public vendorData: IVendorACHAutoPay[] = [];
  @ViewChild('previewIframe') previewIframe!: ElementRef<HTMLIFrameElement>;
  loading = false;
  receiptUrl : SafeResourceUrl | null = null;
  activeRecords: any[];
  public selectionOptions?: SelectionSettingsModel;
  decimalRestrictInput: ITwoDigitDecimalInput = {
      Length: 7,
      IsCurrency: true,
      DefaultMinimum: false,
      MinimumValue: '0.00',
      MaximumValue: '9999999.99',
      WholeValue: false,
    };
  disableACHAfterOneProcess = false;
  searchVendoralphaNumericID = "";
  searchVendorName = "";
  searchVendorSeqId = 0;
  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };
  selectedOption = "0";
  printautoPaySummary = false;
  emailPaymentReceipt = false;
  countVendorsProcessed = 0;
  enableACH = false
  viewPermissionHandlerData: IUserPermissionHandler = {FunctionId: EUserSecurityFunctionID.AutoPayACHVendor, Action: EActionTypes.VIEW};  
  createPermissionHandlerData: IUserPermissionHandler = {FunctionId: EUserSecurityFunctionID.AutoPayACHVendor, Action: EActionTypes.CREATE};

  constructor(
    private autoPayACHService: ACHAutoPayService,
    private commonCalculatorService: CommonCalculatorService,
    private toastr: ToastrService,
    private vendorService: VendorService,
    private generalService: GeneralService,
    private sanitizer: DomSanitizer,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private paymentService: PaymentService
  ) {
  }

  ngOnInit(): void {
    this.selectionOptions = { checkboxOnly: true };
    this.getCredentials();
    this.getACHAutoPayVendors();
  }

  getCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {
        this.enableACH = res.EnableACH;
      }
    })
  }

  getACHAutoPayVendors(vendorId: number = 0) {
    this.loaderIcon = Promise.resolve(true);
    this.autoPayACHService.getACHAutoPayVendors(vendorId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.loaderIcon = Promise.resolve(false);
        if (response) {
          this.vendorData = response.map(data => {
            data.PaymentAmount = '$' + data.BalanceDue.toFixed(2);
            data.ProcessedAmount = 0;
            data.PaymentStatus = '';
            return data;
          });
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error( EToaster.MsgErrorFetch + $localize`:@@AutoPayVendors:AutoPayVendors`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  public created() {
    this.gridAch.element.querySelectorAll('.e-filterdiv')[this.gridAch.getColumnIndexByField('BalanceDue')].classList.add('e-hide');
    this.gridAch.element.querySelectorAll('.e-filterdiv')[this.gridAch.getColumnIndexByField('PaymentAmount')].classList.add('e-hide');
    this.gridAch.element.querySelectorAll('.e-filterdiv')[this.gridAch.getColumnIndexByField('ProcessedAmount')].classList.add('e-hide');
    this.gridAch.element.querySelectorAll('.e-filterdiv')[this.gridAch.getColumnIndexByField('PaymentStatus')].classList.add('e-hide');
    this.gridAch.element.querySelectorAll('.e-filterdiv')[this.gridAch.getColumnIndexByField('ReceiptId')].classList.add('e-hide');
    this.gridAch.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };
  }

  getVendorById(): void {
    const vendorId = this.searchVendoralphaNumericID;
    if (!vendorId) {
      this.searchVendoralphaNumericID = '';
      this.searchVendorName = "";
      this.searchVendorSeqId = 0;
      return;
    }
    this.loaderIcon = Promise.resolve(true);
    this.vendorService.getVendorInfoByMarketVendorId(vendorId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.loaderIcon = Promise.resolve(false);
        if (response?.VendorId) {
          this.searchVendoralphaNumericID = response.MarketVendorId;
          this.searchVendorName = response.VendorName;
          this.searchVendorSeqId = response.VendorId;
          this.getACHAutoPayVendors(this.searchVendorSeqId);
        } else {
          this.searchVendoralphaNumericID = '';
          this.searchVendorName = "";
          this.searchVendorSeqId = 0;
          this.showWarning($localize`Vendor ID does not exist.`);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error( EToaster.MsgErrorFetch + $localize`:@@AutoPayVendor:AutoPayVendor`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  OpenVendorSearch(template: TemplateRef<any>) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const vendorModal = new bootstrap.Modal(
      document.getElementById('vendorSearchModal')!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    vendorModal.show();
  }
  
  hideVendorSearch() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
  
  onVendorSelected(vendor: any) {
    this.searchVendoralphaNumericID = vendor.marketVendorId;
    this.searchVendorName = vendor.vendorName;
    this.searchVendorSeqId = vendor.vendorId;
    this.getACHAutoPayVendors(this.searchVendorSeqId);
    this.hideVendorSearch();
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  isDisablePaymentAmountText(data: IVendorACHAutoPay) {
    if (this.gridAch) {
      const selectedrecords = this.gridAch.getSelectedRecords();
      this.activeRecords = selectedrecords;
      if (this.activeRecords.length !== 0) {
        let i;
        for (i = 0; i < this.activeRecords.length; i++) {
            if (data.VendorId == this.activeRecords[i].VendorId) {
              return false;
            }
        }
      }
    }
    return true
  }
  handleClick(event: any) {
    this.commonCalculatorService.handleClick(event);
  }

  numberOnly(event): boolean {
    return this.commonCalculatorService.numberOnly(event);
  }

  handledblClick(event: any) {
    this.commonCalculatorService.handledblClick(event);
  }

  rowDataBound(args: any): void {
    if (this.disableACHAfterOneProcess) {
      args.isSelectable = false;
    } else {
      args.isSelectable = true;
    }
  }

  openPreview(data) {
    this.processReceiptView(data.VendorId, data);
  }
  
  processReceiptView(vendorId, data) {
    let payload = [];
    const vendorObject = this.vendorData.find(v => v.VendorId == data.VendorId);
    if (vendorObject && vendorObject.ReceiptDocument) {
      if (!vendorObject.ReceiptDocument || !vendorObject.ReceiptDocument.startsWith('data:application/pdf;base64,')) {
        Swal.fire('Error', `Invalid Receipt PDF data in response`, 'error');
        return;
      }
      this.showPDFModal('Receipt', vendorObject.ReceiptDocument);
    } else if (vendorObject && vendorObject['AccountReceiptIds'] && vendorObject['AccountReceiptIds'].length > 0) {
      this.loaderIcon = Promise.resolve(true);
      vendorObject['AccountReceiptIds'].forEach(rec => {
        const params = {
          VendorId: vendorId,
          AccountReceiptId: rec,
          RentalType: 4,
          PaymentOnly: true,
          DocumentId: RentalReceiptIDs.MonthlyReceipt
        };
        payload.push(params);
      });
      this.callCombinedVendorPaymentReceipt(payload, '');
    }
  }
  
  private showPDFModal(type: 'Receipt', base64Data: string) {
    this.loading = true;
    const modalId = 'printReceiptPopup';
    const pdfVar = 'receiptUrl';

    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modalInstance) {
        modalInstance = new window['bootstrap'].Modal(modalEl);
      }
      modalInstance.show();
    }

    const pdfBase64 = base64Data.split(',')[1];
    const blob = this.base64ToBlob(pdfBase64, 'application/pdf');
    this[pdfVar] = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.loading = false;
  }

  private getAllReceiptDocument(data: IVendorACHAutoPay[]) {
    this.countVendorsProcessed = 0;
    let apiCalls: Observable<any>[] = [];
    if (data && data.length > 0) {
      data.forEach(item => {
      let payload = [];
        item['AccountReceiptIds'].forEach(rec => {
          if (rec) {
            const params = {
              VendorId: item.VendorId,
              AccountReceiptId: rec,
              RentalType: 4,
              PaymentOnly: true,
              DocumentId: RentalReceiptIDs.MonthlyReceipt
            };
            payload.push(params);
          }
        });
        apiCalls.push(this.autoPayACHService.generatePaymentReceipts(payload));
      });
    }
    forkJoin(apiCalls).pipe(takeUntil(this.destroy$)).subscribe({
      next: (responses: any[]) => {
        responses.forEach((response, index) => {
          if (response.Success) {
            let vendorObject = this.vendorData.find(record => record.VendorId == response.Id);
            if (vendorObject) {
              vendorObject.ReceiptDocument = response.Message
            }
          }
        });
        this.sendEmail(this.vendorData.filter(x => x.ReceiptDocument));
        this.gridAch.refreshColumns();
      },
      error: (err) => {
      }
    });
  }

  private callCombinedVendorPaymentReceipt(payload, type: string) {
    this.autoPayACHService.generatePaymentReceipts(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.loaderIcon = Promise.resolve(false);
        if (type == 'All') {
          if (res.Success) {
            let vendorObject = this.vendorData.find(record => record.VendorId == payload[0].VendorId);
            if (vendorObject) {
              vendorObject.ReceiptDocument = res.Message
            }
          }
          this.gridAch.refreshColumns();
        }
        else {
          if (!res.Success) return;
          const message = res.Message;
          if (!message || !message.startsWith('data:application/pdf;base64,')) {

            Swal.fire('Error', `Invalid Receipt PDF data in response`, 'error');
            return;
          }
          this.showPDFModal('Receipt', message);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@ACHPaymentReceipt:Payment Receipt`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  private sendEmail(data: IVendorACHAutoPay[]) {
    if (data && data.length > 0) {
      let emailDataList = [];
      data.forEach(item => {
        const emailData = {
          AccountReceiptID: item.AccountReceiptIds[0],
          AccountReceiptIds: item.AccountReceiptIds.join(', '),
          VendorID: item.VendorId,
          BaseTemplateID: 4,
          AttachmentFile: item.ReceiptDocument,
          AttachmentFileName: 'Payment Receipt',
          FileType: "application/pdf",
          Subject: 'Autopay Payment Receipt'
        };
        emailDataList.push(emailData);
      });
      this.generalService.composeEmails(emailDataList).pipe(takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          if (response && response.Success)
          this.toastr.success(EToaster.MsgSuccessSent + $localize`:@@ACHPaymentReceipt:ACH Payment Receipt`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
        },
        error: (error) => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error( EToaster.MsgErrorSend + $localize`:@@ACHPayment:ACH Payment`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        },
      });
    }
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  disableAutoPayBtn() {
    if (this.disableACHAfterOneProcess) {
      return true;
    }
    if (this.vendorData && this.vendorData.length > 0 && this.gridAch) {
      const selectedRecords: Object[] = this.gridAch.getSelectedRecords();
      if (selectedRecords.length > 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validateACHautoPay() {
    Swal.fire({
      title: $localize`:@@Confirm:Confirm`,
      text: $localize`:@@ConfirmACHAutoPay:Are you sure you want to process ACH AutoPay?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`:@@Yes:Yes`,
      cancelButtonText: $localize`:@@No:No`
    }).then((result) => {
      if (result.isConfirmed) {
        this.processACHAutoPay();
      }
    });
  }

  changeRecordPaymentAmt(value, data) {
    console.log(' $$$', event);
    let selectedData = this.vendorData.find(rec => rec.VendorId == data.VendorId);
    selectedData.PaymentAmount = value;
  }

  changeVendorsRadio(event) {
    if(event === 0) {
      this.searchVendoralphaNumericID = '';
      this.searchVendorName = "";
      this.searchVendorSeqId = 0;
      this.getACHAutoPayVendors();
    }
  }

  clearAutoPay() {
    this.searchVendoralphaNumericID = '';
    this.searchVendorName = "";
    this.searchVendorSeqId = 0;
    this.selectedOption = "0";
    this.disableACHAfterOneProcess = false;
    this.printautoPaySummary = false;
    this.emailPaymentReceipt = false;
    this.countVendorsProcessed = 0;
    this.getACHAutoPayVendors();
  }

  processACHAutoPay() {
    this.loaderIcon = Promise.resolve(true);
    const selectedRecords: Object[] = this.gridAch.getSelectedRecords();
    selectedRecords.forEach(item => {
      item['PaymentAmount'] = this.commonCalculatorService.getActualAmountFromInp(item['PaymentAmount']);
    });
    this.autoPayACHService.processACHAutoPayVendors(selectedRecords).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: IVendorACHAutoPay[]) => {
        this.loaderIcon = Promise.resolve(false);
        if (response && response.length > 0) {
          if (response.findIndex(r => !r.Success) != -1) {
            this.toastr.error( EToaster.MsgErrorSave + $localize`:@@OneOrMoreACHPayment:One or more ACH Payment`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
          } else {
            this.toastr.success(EToaster.MsgSuccessSave + $localize`:@@ACHPayment:ACH Payment`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
          }
          this.disableACHAfterOneProcess = true;
          response.forEach(rec => {
            const recordObject = this.vendorData.find(v => v.VendorId == rec.VendorId);
            if (recordObject) {
              recordObject['AccountReceiptIds'] = rec.AccountReceiptIds;
              recordObject.ReceiptId = (rec.AccountReceiptIds && rec.AccountReceiptIds.length > 0) ? rec.AccountReceiptIds.join(', ') : null;
              recordObject.ProcessedAmount = this.commonCalculatorService.getActualAmountFromInp(recordObject['PaymentAmount']);
              recordObject.PaymentStatus = rec.Success ? 'Success' : ( rec.Message ?? "Failure") ;
              this.gridAch.refresh();
              this.created();
            }
          });
          if (this.printautoPaySummary) {
            this.printAutoPaySummary(response);
          }
          if (this.emailPaymentReceipt) {
            this.getAllReceiptDocument(response);
          }
        } else {
          this.toastr.error( EToaster.MsgErrorSave + $localize`:@@ACHPayment:ACH Payment`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error( EToaster.MsgErrorSave + $localize`:@@ACHPayment:ACH Payment`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  printAutoPaySummary(response: IVendorACHAutoPay[]) {
    if (response.length > 0) {
      this.loaderIcon = Promise.resolve(true);
      this.autoPayACHService.generateAutoPaySummary(response.filter(r => (r.Success || (!r.Success && r.Message)))).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.loaderIcon = Promise.resolve(false);
          if (!res.Success) return;
          const message = res.Message;
          if (!message || !message.startsWith('data:application/pdf;base64,')) {
            Swal.fire('Error', `Invalid Auto Pay ACH Summary PDF data in response`, 'error');
            return;
          }
          this.showPDFModal('Receipt', message);
        },
        error: (error) => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@ACHAutoPaySummary:Auto Pay ACH Summary`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        },
      });
    }
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }
  
}
